import {h} from 'preact';
import {createPortal} from 'preact/compat';
import {useState} from "preact/hooks";
import adminService from "../service/adminService";
import Spinner2 from "./Spinner2";

export default function CleanUploadsModal({open, onClose}) {
  const [member, setMember] = useState("");
  const [loading, setLoading] = useState(false);

  function cleanUploads() {
    if (!member) return;

    setLoading(true);
    adminService.removeUploads(member).then(resp => {
      setLoading(false);
      setMember("");
    }).catch(() => {
      setLoading(false);
    })
  }

  return !open ? null : createPortal(<div>
    <div className="modal-back" onClick={onClose} />
    <div className="modal">
      <header>
        <h2>Clean uploads</h2>
      </header>
      <div className="content">
        <p>Remove uploads for any member account.</p>
        <label>Email / ID (Supports multiple comma separated values)</label>
        <input type={"text"} value={member} onchange={ev => setMember(ev.target.value)} placeholder={"dev@mhm.com,cs@mhm.com"}/>


        {loading && <Spinner2 />}

        {!loading && <footer style={{marginTop: "15px"}}>
          <a className="btn decline" onClick={onClose}>Close</a>
          <a className="btn primary accept" onClick={cleanUploads}>Clean</a>
        </footer>}
      </div>
    </div>
  </div>, document.getElementById('modals'));
}
